// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //chatapp config
//   firebase : {
//   apiKey: "AIzaSyB15JeeF6aYy-JqJQ9HEKdaNMcEjEkDpH8",
//   authDomain: "chatapp-5b453.firebaseapp.com",
//   databaseURL: "https://chatapp-5b453.firebaseio.com",
//   projectId: "chatapp-5b453",
//   storageBucket: "chatapp-5b453.appspot.com",
//   messagingSenderId: "106885786136",
//   appId: "1:106885786136:web:798cf0d79a3c3197bbf16d",
//   measurementId: "G-MSZ4BXWBED"
// }
//lovy config
  firebase : {
   apiKey: "AIzaSyCcgn7Y17Ez7V40i96QP7ENPgH56ID5AjE",
  authDomain: "lovychat.firebaseapp.com",
  databaseURL: "https://lovychat.firebaseio.com",
  projectId: "lovychat",
  storageBucket: "lovychat.appspot.com",
  messagingSenderId: "496560878222",
  appId: "1:496560878222:web:09c1bb19a61e22552fcfdf",
  measurementId: "G-SV8RVBXNVJ"
}

  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
